// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1X-MC","header":"Messages_header__2cVxG"};